import { TypeCongeCompteurEnum } from "../dto/GenApi.iNotPaie.Dto/TypeCongeCompteurEnum";

interface ICardInformations {
    title: string,
    backgroundColor: string,
    data: {
        joursRestants: number,
        joursRestantsColor: string,
        joursAcquis: number,
        joursAcquisColor: string,
        joursPoses: number,
        joursPosesColor: string,
        joursPris: number,
        joursPrisColor: string
    }
}

type TypeCardInformationsByType = {
    [key in TypeCongeCompteurEnum]: ICardInformations;
};

const CardInformationsByType: TypeCardInformationsByType = {
    [TypeCongeCompteurEnum.Rtt]: {
        title: "RTT",
        backgroundColor: "#fff3ed",
        data: {
            joursRestants: 0,
            joursRestantsColor: "#FE3A11",
            joursAcquis: 0,
            joursAcquisColor: "#57617a",
            joursPoses: 0,
            joursPosesColor: "#FF9E89",
            joursPris: 0,
            joursPrisColor: "#e1e7f2"
        }
    },
    [TypeCongeCompteurEnum.N]: {
        title: "Congés payés N",
        backgroundColor: "#F6F3FF",
        data: {
            joursRestants: 0,
            joursRestantsColor: "#8838EF",
            joursAcquis: 0,
            joursAcquisColor: "#57617a",
            joursPoses: 0,
            joursPosesColor: "#B37DF8",
            joursPris: 0,
            joursPrisColor: "#e1e7f2"
        }
    },
    [TypeCongeCompteurEnum.NMoins1]: {
        title: "Congés payés N-1",
        backgroundColor: "#eff3ff",
        data: {
            joursRestants: 0,
            joursRestantsColor: "#3660F4",
            joursAcquis: 0,
            joursAcquisColor: "#57617a",
            joursPoses: 0,
            joursPosesColor: "#7090FE",
            joursPris: 0,
            joursPrisColor: "#e1e7f2"
        }
    }
};

export {
    ICardInformations,
    TypeCardInformationsByType,
    CardInformationsByType
};



// WEBPACK FOOTER //
// ./src/config/Absences.config.ts